// Admin-only blockchain operations. All calls go through the backend proxy
// (/api/investment/admin/*), which enforces admin auth before reaching the
// wallet- and chain-services.
const API = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const isForm = opts.body instanceof FormData;
  const r = await fetch(`${API}/api/investment/admin${path}`, {
    credentials: "include",
    ...opts,
    headers: isForm ? opts.headers : { "Content-Type": "application/json", ...opts.headers },
  });
  if (!r.ok) {
    let msg = r.statusText;
    try {
      const b = await r.json();
      msg = b.detail || b.message || msg;
      if (Array.isArray(msg)) msg = msg.map((m) => m.msg || m).join(", ");
    } catch {}
    throw new Error(msg);
  }
  return r.json();
}

export const getChainOverview = () => req("/overview");

export const setContractPaused = (paused) =>
  req(`/contract/${paused ? "pause" : "unpause"}`, { method: "POST" });

export const getAdminCollections = () => req("/collections");

export const createCollection = (fields, imageFile) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") fd.append(k, String(v));
  });
  fd.append("image", imageFile);
  return req("/collections", { method: "POST", body: fd });
};

export const mintMoreSupply = (collectionId, amount) =>
  req(`/collections/${collectionId}/mint`, {
    method: "POST",
    body: JSON.stringify({ amount }),
  });

export const getAdminOrders = () => req("/orders");

export const getAdminWithdrawals = () => req("/withdrawals");

export const getAdminWallets = () => req("/wallets");

export const topUpGas = (address) =>
  req("/wallets/gas-topup", { method: "POST", body: JSON.stringify({ address }) });
